import * as React from 'react';
/**
 *
 * Original name: to do list
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=2916%3A1032
 *
 */
export const ToDoListLine = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.532 11h-5.5V5.5h5.5V11Zm-1.5-4h-2.5v2.5h2.5V7Zm1.5 11.5h-5.5V13h5.5v5.5Zm-1.5-4h-2.5V17h2.5v-2.5Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" }),
    React.createElement("path", { d: "M19.032 7.5h-6.5V9h6.5V7.5Zm-6.5 7.5h6.5v1.5h-6.5V15Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
